(() => {
  if (window.cvTestimonialsInit) return;
  window.cvTestimonialsInit = true;

  const SECTION = '[data-cv-testimonials]';
  const TRACK = '[data-cv-testimonials-track]';

    const syncArrows = (track) => {
    const section = track.closest(SECTION);
    if (!section) return;

    const prev = section.querySelector('[data-cv-testimonials-prev]');
    const next = section.querySelector('[data-cv-testimonials-next]');
    const max = track.scrollWidth - track.clientWidth;

    if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 1);
    if (next) next.toggleAttribute('disabled', track.scrollLeft >= max - 1);
  };

  const bind = () => {
    for (const track of document.querySelectorAll(TRACK)) {
      if (track.dataset.cvBound) continue;
      track.dataset.cvBound = 'true';

      syncArrows(track);
      track.addEventListener('scroll', () => syncArrows(track), { passive: true });
      window.addEventListener('resize', () => syncArrows(track));
    }
  };

  // Délégation : une seule écoute, quel que soit le nombre d'instances.
  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '[data-cv-testimonials-prev], [data-cv-testimonials-next]'
    );
    if (!button) return;

    const track = button.closest(SECTION)?.querySelector(TRACK);
    const card = track?.querySelector('.cv-testimonial');
    if (!track || !card) return;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const direction = button.hasAttribute('data-cv-testimonials-next') ? 1 : -1;

    track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  // Le personnalisateur re-rend la section sans recharger la page.
  document.addEventListener('shopify:section:load', bind);
})();
